import {deDE} from '@mui/x-date-pickers/locales';

export const API_BASE_URL = process.env.GATSBY_API_BASE_URL || '/api';
export const MAX_COUNT_QUERY_ITEMS = 1000;
export const MIN_SEARCH_LENGTH = 2;
export const MASS_SEARCH_MAX_NUMBERS = 500;
export const MAX_FILE_SIZE = 2048; // in MB
export const MAX_FILES_COUNT = 20;
export const STRUCTURE_ID_MEDIENEINGANG = 'PERS_MEDIENEINGANG';
export const STRUCTURE_ID_FAVORITE_ASSETS = 'FAVORITE_ASSETS';
// Kachelansicht höchste Größe
export const MAX_LINE_HEIGHT = 70;
export const EMPTY_FAVORITE_STRUCTURE_GROUPS_HEIGHT = 126;
export const PAGE_SIZE = 48;
export const SIDE_BAR_WIDTH = 380;
export const PREVIEW_UPLOAD_FILE_TYPES = 'image/*,application/pdf';
export const TIFF_TYPE = 'image/tiff';
export const REGEX_SHOWABLE_IMAGES = /image\/(png|jpg|jpeg)/i;
export const REGEX_PREVIEW_ABLE = /(image.*|application\/pdf)/;
export const REGEX_PRODUCT_ASSET_NAME =
  /^P?\d+(_[A-Z]{3}(-0[2-9]|-10)?(--[0-9A-Z]{2,3})?)(_[A-Z0-9]{2,5}(_[a-zA-Z]+)?)?\.[a-zA-Z0-9]{2,4}$/;
export const REGEX_OTHER_ASSET_NAME = /^([A-Z]{3})_[^\s]+\.[a-zA-Z0-9]{2,4}$/;
export const REGEX_MASSSEARCH_PATTERN = /[;/\s]+/;
export const PASSWORD_EXPIRES_WARNING_DAYS = 14;
export const MIN_PASSWORD_LENGTH = 8;
export const WORKER_SIZE =
  typeof navigator !== 'undefined'
    ? Math.min(16, navigator.hardwareConcurrency || 8)
    : 8;
export const FILE_SIZE_FIELD = 'PKOM_PSIZE';
export const MESSAGE_DURATION_LONG = 5000;
export const CARD_WIDTH_PX = 374;
export const CARD_HEIGHT_PX = 163;
export const CARD_MARGIN_PX = 10;
export const TABLE_ROW_HEIGHT_PX = 80;
export const TOOLBAR_CONTENT_HEIGHT_PX = 58;
export const IMAGE_EDITOR_THUMBNAIL_HEIGHT = 60;
export const IMAGE_EDITOR_THUMBNAIL_WIDTH = 60;
/** Sicherheits-Timeout in ms für Loading-Reset beim Infinite Scroll */
export const VIRTUALIZATION_LOADING_TIMEOUT = 5000;
export const ABORT_SEARCH_SILENT = 'ABORT_SEARCH_SILENT';

export const NO_AI_IMAGE = 'NO_AI_IMAGE';
export const AI_IMAGE = 'AI_IMAGE';

export const DATE_FORMAT = 'TT.MM.JJJJ';
export const PKOM_TYPE_IMAGE = 'images';

export const MEDIUM_SCREEN_MIN_WIDTH = 1001;
export const MEDIUM_SCREEN_MAX_WIDTH = 1450;

export const DERIVATE_PREVIEW_LARGE = 'preview_large';
export const DERIVATE_PREVIEW_MEDIUM = 'preview_medium';
export const IMQUERY_POLICY = '.auto';

export const IMAGE_EDITOR_LOCAL_STORAGE_KEY = 'IMAGE_EDITOR_LOCAL_STORAGE_KEY';
export const PENDING_APP_VIEW_SESSION_STORAGE_KEY =
  'PENDING_APP_VIEW_SESSION_STORAGE_KEY';

export const germanLocale =
  deDE.components.MuiLocalizationProvider.defaultProps.localeText;

export const TABLE_VIEW_DEFAULT = {
  IMI_ITEM22: true,
  IMI_ITEM14: true,
  IMI_ITEM3: true,
  PKOM_MNAME: true,
  IMI_ITEM25: true,
  IMI_ITEM1: true,

  IMI_ITEM18: false,
  IMI_ITEM4: false,
  IMI_ITEM15: false,
  IMI_ITEM20: false,
  IMI_ITEM9: false,
};

export const ASSET_METADATA_FIELDS = [
  {
    id: 'fieldsGeneral',
    name: 'Allgemein',
    order: 0,
    fields: [
      'IMI_ITEM1', //Status
      'IMI_ITEM39', //Änderungsdatum
      'IMI_ITEM25', // Aktuelle Version
      'IMI_ITEM15', //EDM
      'IMI_ITEM3', //GTIN
      'IMI_ITEM28', // PIM Artikelnummer
      'IMI_ITEM14', //Artikelbezeichnung
      'IMI_ITEM4', //Bildtyp
      'IMI_ITEM23', // Bildtyp-Nr.
      // "IMI_ITEM2", // Keine GTIN
      //  "IMI_ITEM7", // Qualität ok
      'IMI_ITEM20', // Gültig ab
      'IMI_ITEM9', // Gültig bis
      'IMI_ITEM32', // Markenbild
      'IMI_ITEM29', // Versorgung
      'IMI_ITEM47', // Bildqualität
      'IMI_ITEM19', //Auslobungstexte
      'IMI_ITEM48', // AI Bild
      'IMI_ITEM17', // Inhalt
      'IMI_ITEM18', // Grammatur
      // "IMI_ITEM21", // NFCM
      'IMI_ITEM22', // Markenname
      'IMI_ITEM24', // SAP Warengruppe
      'IMI_ITEM26', // Verpackungseinheit
      'IMI_ITEM30', // Regionskennung

      // "IMI_ITEM6", // Bericht
      'IMI_ITEM8', // Copyright
      'IMI_ITEM10', // Copyright Vermerk
      'IMI_ITEM11', // Kommentar
      'IMI_ITEM12', // Kollektion
      'IMI_ITEM13', // Schlagworte
      'IMI_ITEM16', // Markentyp
      // "IMI_ITEM99", // Fehlerzustand
      'IMI_ITEM40', // Fehlerzustand
      'IMI_ITEM41', // Freigabebericht
      'IMI_ITEM42', // Dateinamensprüfung-Bericht
    ],
  },
  {
    id: 'fieldsTechnical',
    name: 'Technisch',
    order: 1,
    fields: [
      'IMI_PKOM_PNR',
      'PKOM_MNAME',
      'PKOM_COLS',
      'PIMG_FARBRAUM',
      'PIMG_PROF1',
      'PKOM_RESOL',
      'PKOM_PIXELS',
      'PKOM_PSIZE',
      'PIMG_ANG_AM',
      'PIMG_ANG_VON',
    ],
  },
];

export const FILE_NAME_EXAMPLES = [
  {
    name: 'Produktbilder (GTIN)',
    examples: [
      '4019736007333_VOR.tif',
      '4004942700925_VOR-02.tif',
      '4006840003528_PER_NB.tif',
    ],
  },
  {
    name: 'Produktbilder (SAP-Nr.)',
    examples: [
      'P3974896004_PER.tif',
      'P3974896004_PER-02.tif',
      'P3974896004_PER_NB.tif',
    ],
  },
  {
    name: 'Logos',
    examples: ['LOG_DLG-Gold.tif'],
  },
  {
    name: 'Werbe-Druckvorlage',
    examples: ['WDR_PLAKAT-WWF2020-PANDA.tif (oder .zip)'],
  },
];

export const DERIVATE_FILE_SIZE_PERCENTAGE = {
  '1': 0.024178285,
  '2': 0.06375235,
  '3': 0.68714459,
  '4': 0.465188705,
  '5': 0.011556981,
  '6': 0.001880686,
  '7': 0.002322684,
  '8': 0.000812445,
  '9': 0.000998275,
  '10': 0.002198051,
  '11': 0.011745143,
  '12': 0.011998886,
  '13': 0.024419807,
  '14': 0.057247007,
  '15': 0.038492485,
  '16': 1.354719042,
  '17': 0.07990591,
  '18': 0.1,
};

export const USER_ATTRIBUTE_CONVERT = {
  id: 'User-ID',
  username: 'Benutzername',
  firstname: 'Vorname',
  lastname: 'Nachname',
  email: 'E-Mail',
  telefon: 'Telefon',
  usergroups: 'Benutzergruppen',
  locked: 'Gesperrt',
  pimuser: '',
};

export const CREATE_USER_ATTRIBUTES = [
  'username',
  'firstname',
  'lastname',
  'email',
  'telefon',
  'locked',
  'usergroups',
];

export const MAX_FILTER_COUNT_EXTENDED_SEARCH = 5;

export const EXTENDED_SEARCH_FIELDS = [
  'IMI_PKOM_PNR', // ID
  'IMI_ITEM1', //Status
  'IMI_ITEM39', //Änderungsdatum
  'IMI_ITEM25', // Aktuelle Version
  'IMI_ITEM15', //EDM
  'IMI_ITEM3', //GTIN
  'IMI_ITEM28', // PIM Artikelnummer
  'IMI_ITEM14', //Artikelbezeichnung
  'IMI_ITEM4', //Bildtyp
  'PKOM_MNAME', //Dateiname
  'IMI_ITEM23', // Bildtyp-Nr.
  'IMI_ITEM20', // Gültig ab
  'IMI_ITEM9', // Gültig bis
  'IMI_ITEM32', // Markenbild
  'IMI_ITEM29', // Versorgung
  'IMI_ITEM19', //Auslobungstexte
  'IMI_ITEM47', // Bildqualität
  'IMI_ITEM48', // KI Bild
  'IMI_ITEM17', // Inhalt
  'IMI_ITEM18', // Grammatur
  'IMI_ITEM22', // Markenname
  'IMI_ITEM24', // SAP Warengruppe
  'IMI_ITEM26', // Verpackungseinheit
  'IMI_ITEM30', // Regionskennung
  'IMI_ITEM8', // Copyright
  'IMI_ITEM10', // Copyright Vermerk
  'IMI_ITEM11', // Kommentar
  'IMI_ITEM12', // Kollektion
  'IMI_ITEM13', // Schlagworte
  'IMI_ITEM16', // Markentyp
  'IMI_ITEM99', // Fehlerzustand
  'IMI_ITEM40', // Fehlerzustand
  'IMI_ITEM41', // Freigabebericht
  'IMI_ITEM42', // Dateinamensprüfung-Bericht
  'PKOM_PSIZE', // Dateigröße
];

export const OPERATOR_NAMES = {
  CONTAINS: 'enthält',
  NOT_CONTAINS: 'enthält nicht',
  EQUAL: 'gleich',
  NOT_EQUAL: 'ungleich',
  GREATER: 'größer als',
  LESS: 'kleiner als',
};
